import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function CursAbcPricing() {
  const inclusions = ['Cursul complet ABC-ul Prosperității, video structurat în lecții clare, acces pe viață', 'Exerciții practice pentru identificarea credințelor limitative', 'Tehnici de eliminare a blocajelor mentale', 'Afirmații ghidate pentru prosperitate', 'Exercițiul Harta Comorilor (vizualizare + direcție)', 'Explicații clare despre adevărata bogăție'];
  return <section id="inscriere" className="py-24 lg:py-32 bg-[#4F2E7E] relative scroll-mt-24 overflow-hidden" data-id="element-920">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-921" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-922" />

      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-923">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-2xl" data-id="element-924">
          <SectionHeading title="Ce primești și care este investiția ta" className="!mb-8" data-id="element-925" />

          <div className="bg-brand-cream rounded-2xl p-6 md:p-8 mb-8 border border-brand-text/5" data-id="element-926">
            <h3 className="font-bold text-lg mb-4 text-brand-text" data-id="element-927">
              CE E INCLUS:
            </h3>
            <ul className="space-y-4" data-id="element-928">
              {inclusions.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-929">
                  <div className="mt-1 bg-brand-gold/20 rounded-full p-1 flex-shrink-0" data-id="element-930">
                    <Check className="w-4 h-4 text-brand-gold" data-id="element-931" />
                  </div>
                  <span className="text-brand-text/80 font-medium" data-id="element-932">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8 p-6 border-2 border-brand-gold/20 rounded-2xl bg-brand-gold/5" data-id="element-933">
            <div className="text-center md:text-left" data-id="element-934">
              <span className="block text-brand-textSec text-sm font-bold uppercase tracking-wider mb-1" data-id="element-935">
                Valoare reală
              </span>
              <span className="text-2xl text-brand-text/50 line-through decoration-2" data-id="element-936">
                900 lei
              </span>
            </div>

            <div className="text-center md:text-right" data-id="element-937">
              <span className="block text-brand-purple text-sm font-bold uppercase tracking-wider mb-1" data-id="element-938">
                Preț special
              </span>
              <div className="flex items-baseline gap-2 justify-center md:justify-end" data-id="element-939">
                <span className="text-5xl md:text-6xl font-heading font-bold text-brand-gold" data-id="element-940">
                  500
                </span>
                <span className="text-2xl font-bold text-brand-gold" data-id="element-941">lei</span>
              </div>
              <span className="inline-block mt-2 text-sm font-bold text-green-600 bg-green-100 px-3 py-1 rounded-full" data-id="element-942">
                Economisești 400 lei
              </span>
            </div>
          </div>

          <div className="flex justify-center mb-8" data-id="element-943">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-bold border border-red-100" data-id="element-944">
              <span data-id="element-945">🔥</span> Locuri limitate la prețul de lansare
            </div>
          </div>

          <a href="https://link.apisystem.tech/widget/form/9zfPKqrDXfAV9yiajCNl" target="_top" className="group flex items-center justify-center gap-3 w-full bg-brand-gold text-white font-heading font-bold text-xl md:text-2xl py-5 md:py-6 rounded-2xl hover:bg-brand-purple transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 mb-6" data-id="element-946">
            Vreau Cursul ABC-ul Prosperității
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-947" />
          </a>

          <p className="text-center text-sm text-brand-textSec mb-8 px-4" data-id="element-948">
            Notă: Membrii Academiei de Abundență (Programul Standard sau
            Premium) beneficiază de o reducere de 20% la acest curs.
          </p>

          <div className="text-center pt-6 border-t border-brand-text/10" data-id="element-949">
            <p className="text-brand-text/80 text-sm mb-3" data-id="element-950">
              Sau înscrie-te în Academia de Abundență și primești acest curs
              împreună cu toate celelalte 5 cursuri, plus întâlniri de grup.
            </p>
            <a href="https://project-hearty-oatmeal-874.magicpatterns.app/" className="inline-flex items-center gap-2 text-brand-purple font-bold hover:text-brand-gold transition-colors underline underline-offset-4 decoration-2" data-id="element-951">
              Vezi Programele Academiei
              <ArrowRight className="w-4 h-4" data-id="element-952" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}